export function accountBaseForRole() {
  return '/apps/account';
}
